import { NeutralButton, PrimaryButton, toast } from '@systemeio/ui';
import { finishSplitTest, removeSplitTestVariant, startSplitTest } from 'modules/funnels/funnel/api/funnel-api';
import ChooseTestVariantModal from 'modules/funnels/funnel/components/split-tests-tab/choose-test-variant-modal';
import SplitTestItem from 'modules/funnels/funnel/components/split-tests-tab/split-test-item';
import TabTable from 'modules/funnels/funnel/components/tab-table';
import { SplitTestComponentTypeEnum } from 'modules/funnels/funnel/enums/split-tests-component-type-enum';
import { useFunnelStepTests } from 'modules/funnels/funnel/hooks/use-funnel-step-tests';
import { useFunnelStepTestsHistory } from 'modules/funnels/funnel/hooks/use-funnel-step-tests-history';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useSplitTestTableColumns } from 'modules/funnels/funnel/hooks/use-split-test-table-columns';
import { useUpdateFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-update-funnel-step-query';
import PlayIcon from 'modules/funnels/funnel/icons/play-icon';
import StopIcon from 'modules/funnels/funnel/icons/stop-icon';
import TestsIcon from 'modules/funnels/funnel/icons/tests-icon';
import TrashIcon from 'modules/funnels/funnel/icons/trash-icon';
import { FunnelStepId, FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { NotStartedSplitTestInterface, SplitTestInterface, SplitTestType } from 'modules/funnels/funnel/types/funnel-tests-interface';
import { getRunningTestTableData, isSplitTestIsEmptyArray, isSplitTestIsNotStarted, isSplitTestIsStarted } from 'modules/funnels/funnel/utils/split-tests-utils';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface SplitTestActionItemProps {
  data: SplitTestType;
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface;
}
function SplitTestActions({
  data,
  funnelId,
  funnelStep
}: SplitTestActionItemProps) {
  const {
    t
  } = useLocoTranslation();
  const [isDeleteVariantOpen, setIsDeleVariantOpen] = useState(false);
  const [isEndSplitTestOpen, setIsEndSplitTestOpen] = useState(false);
  const {
    mutateSplitTest
  } = useFunnelStepTests(funnelStep.id);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    mutateHistoryData
  } = useFunnelStepTestsHistory(funnelStep.id);
  const columns = useSplitTestTableColumns({
    withEndDate: false
  });
  const {
    updateFunnelStepQuery
  } = useUpdateFunnelStepQuery();
  const [isFetching, setIsFetching] = useState(false);
  const handleDeleteVariant = async () => {
    const castedData = data as NotStartedSplitTestInterface;
    setIsFetching(true);
    await removeSplitTestVariant(funnelStep.id);
    await mutateFunnelStepsList(data_0 => {
      if (data_0) {
        return data_0.map(funnelStep_0 => {
          if (funnelStep_0.id === castedData.funnelStepA.id || funnelStep_0.id === castedData.funnelStepB.id) {
            return {
              ...funnelStep_0,
              inRunningSplitTest: false,
              currentSplitTest: null
            };
          }
          if (funnelStep_0.id === castedData.goalFunnelStep.id) {
            return {
              ...funnelStep_0,
              goalFunnelStepOfAnySplitTest: false,
              currentSplitTest: null
            };
          }
          return funnelStep_0;
        });
      }
    }, false);
    await mutateSplitTest([], false);
    setIsFetching(false);
  };
  const handleEndSplitTest = async () => {
    setIsFetching(true);
    const castedData_0 = data as SplitTestInterface;
    const response = await finishSplitTest(funnelStep.id);
    await mutateHistoryData(response.data, false);
    await mutateFunnelStepsList(data_1 => {
      if (data_1) {
        return data_1.map(funnelStep_1 => {
          if (funnelStep_1.id === castedData_0.splitTest.funnelStepA.id || funnelStep_1.id === castedData_0.splitTest.funnelStepB.id) {
            return {
              ...funnelStep_1,
              inRunningSplitTest: false,
              currentSplitTest: null
            };
          }
          if (funnelStep_1.id === castedData_0.splitTest.goalFunnelStep.id) {
            return {
              ...funnelStep_1,
              goalFunnelStepOfAnySplitTest: false,
              currentSplitTest: null
            };
          }
          return funnelStep_1;
        });
      }
    }, false);
    await mutateSplitTest([], false);
    setIsFetching(false);
  };
  const handleStartSplitTest = async () => {
    try {
      setIsFetching(true);
      const response_0 = await startSplitTest(funnelStep.id);
      await mutateSplitTest(response_0.data, false);
      await mutateFunnelStepsList(data_2 => {
        if (data_2) {
          return data_2.map(funnelStep_2 => {
            if (funnelStep_2.id === response_0.data.splitTest.funnelStepA.id || funnelStep_2.id === response_0.data.splitTest.funnelStepB.id) {
              return {
                ...funnelStep_2,
                inRunningSplitTest: true,
                currentSplitTest: {
                  id: response_0.data.splitTest.id,
                  funnelStepA: {
                    id: response_0.data.splitTest.funnelStepA.id,
                    page: response_0.data.splitTest.funnelStepA.page
                  },
                  funnelStepB: {
                    id: response_0.data.splitTest.funnelStepB.id,
                    page: response_0.data.splitTest.funnelStepB.page
                  }
                }
              };
            }
            return funnelStep_2;
          });
        }
      }, false);
    } catch (error) {
      toast.error(t('global.error'));
    } finally {
      setIsFetching(false);
    }
  };
  const handleChangeFunnelStepConfigurationTab = (id: FunnelStepId) => {
    updateFunnelStepQuery(id);
  };
  if (isSplitTestIsEmptyArray(data)) {
    return <div className="mx-auto flex gap-3 px-4 lg:gap-10 lg:px-0">
        <SplitTestItem type={SplitTestComponentTypeEnum.original} funnelStep={funnelStep} />
        <div className="font-inter text-text-primary flex flex-[33_1_0%] flex-col items-center justify-center gap-4 text-[15px] lg:text-lg">
          <TestsIcon active={false} className="h-[73px] w-[85px] lg:h-[104px] lg:w-[121px]" />
          <div className="font-bold">{t('dashboard.funnel.split_tests.start_test')}</div>
          <div className="text-center text-sm opacity-60 lg:text-base">
            {t('dashboard.funnel.split_tests.create_test_description')}
          </div>
          <ChooseTestVariantModal funnelId={funnelId} funnelStep={funnelStep} />
        </div>
      </div>;
  }
  if (isSplitTestIsNotStarted(data)) {
    const castedData_1 = data as NotStartedSplitTestInterface;
    return <>
        <div className="flex flex-col gap-5">
          <div className="flex flex-wrap gap-10 lg:mx-auto ">
            <SplitTestItem type={SplitTestComponentTypeEnum.original} funnelStep={castedData_1.funnelStepA} className="order-1" />
            <div className="font-inter text-text-primary order-3 flex w-full flex-[33_1_0%] flex-col items-center justify-center gap-4 text-base lg:text-lg xl:order-2">
              <div className="font-bold ">{t('dashboard.funnel.split_tests.start_test_title')}</div>
              <div className="text-center text-sm opacity-60 lg:text-base">
                {t('dashboard.funnel.split_tests.start_test_description')}
              </div>
              <div className="flex gap-2">
                <PrimaryButton onClick={handleStartSplitTest} isFetching={isFetching}>
                  <PlayIcon />
                  {t('dashboard.funnel.split_tests.start_test')}
                </PrimaryButton>
                <NeutralButton className={'[&_svg]:hover:fill-red hover:border-red [&_svg]:main-transition-colors'} onClick={() => setIsDeleVariantOpen(true)}>
                  <TrashIcon />
                </NeutralButton>
              </div>
            </div>
            <SplitTestItem type={SplitTestComponentTypeEnum.variant} funnelStep={castedData_1.funnelStepB} className="order-2 xl:order-3" />
          </div>
          <hr className={'color-text-primary w-full opacity-10'} />
          <div className="font-inter text-text-primary flex flex-col items-center justify-start gap-4 text-[15px] lg:text-base">
            <div className="flex flex-col items-center justify-center gap-1">
              <div className="opacity-60">{t('dashboard.funnel.split_tests.goal_funnel_step')}</div>
              <div className="cursor-pointer font-bold" onClick={() => handleChangeFunnelStepConfigurationTab(castedData_1.goalFunnelStep.id)}>
                {castedData_1.goalFunnelStep.name}
              </div>
            </div>
          </div>
        </div>
        <Confirmation confirmationText={t('dashboard.funnel.split_tests.remove_variant_confirmation')} opened={isDeleteVariantOpen} onClose={() => setIsDeleVariantOpen(false)} onConfirm={handleDeleteVariant} toastCaption={t('dashboard.funnel.split_tests.deleted_variant_toast')} />
      </>;
  }
  if (isSplitTestIsStarted(data)) {
    const castedData_2 = data as SplitTestInterface;
    const tableData = getRunningTestTableData(castedData_2);
    return <>
        <div className="flex flex-col gap-5">
          <div className="flex flex-wrap gap-10 lg:mx-auto ">
            <SplitTestItem type={SplitTestComponentTypeEnum.original} funnelStep={castedData_2.splitTest.funnelStepA} className={'order-1'} />
            <div className="order-3 flex w-full min-w-max flex-1 flex-col items-center justify-center gap-4 lg:w-auto xl:order-2">
              <div className="font-inter text-text-primary flex flex-[33_1_0%] flex-col items-center justify-center gap-4 text-base lg:text-lg">
                <div className="text-center font-bold">
                  {t('dashboard.funnel.split_tests.started')}
                </div>
                <PrimaryButton onClick={() => setIsEndSplitTestOpen(true)}>
                  <StopIcon />
                  {t('dashboard.funnel.split_tests.end_test')}
                </PrimaryButton>
              </div>
            </div>
            <SplitTestItem type={SplitTestComponentTypeEnum.variant} funnelStep={castedData_2.splitTest.funnelStepB} className={'order-2 xl:order-3'} />
          </div>
          <hr className={'color-text-primary w-full opacity-10'} />
          <div className="font-inter text-text-primary flex flex-col items-center justify-start gap-4 text-[15px] lg:text-base">
            <div className="flex flex-col items-center justify-center gap-1">
              <div className="opacity-60">{t('dashboard.funnel.split_tests.goal_funnel_step')}</div>
              <div className="cursor-pointer font-bold" onClick={() => handleChangeFunnelStepConfigurationTab(castedData_2.splitTest.goalFunnelStep.id)}>
                {castedData_2.splitTest.goalFunnelStep.name}
              </div>
            </div>
          </div>
        </div>
        <Confirmation confirmationText={t('dashboard.funnel.split_tests.finish_test_confirmation')} opened={isEndSplitTestOpen} onClose={() => setIsEndSplitTestOpen(false)} onConfirm={handleEndSplitTest} toastCaption={t('dashboard.funnel.split_tests.finish_test_toast')} />
        <div className="lg:px-8">
          <TabTable columns={columns} data={tableData} passDataToHeader />
        </div>
      </>;
  }
  return <></>;
}
export default SplitTestActions;